<template>
    <div v-if="!loading">
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-2">
            <div v-for="(item, index) in getByKey('twitter').data" :key="item.id">
                <TwitterItem :data="item" :index="index" v-model:active="active" />
            </div>
        </div>

        <div class="flex justify-end mt-4">
            <Pagination :limit="-1" :data="getByKey('twitter')" @pagination-change-page="paginate" />
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import _ from 'lodash';

export default {
    data: () => ({
        loading: false,
        active: 0
    }),
    mounted() {
        this.indexSocialMedia();
    },
    props: [],
    methods: {
        paginate(page) {
            this.loading = true;
            this.active = 0;
            this.indexSocialMedia({
                page: page
            });
        },
        async indexSocialMedia(params) {
            this.loading = true;
            let config = {
                params: {
                    'sort[by]': 'created_at',
                    'sort[order]': 'desc',
                    key: 'twitter',
                    limit: 4,
                    type: ['twitter'],
                    has_image: true
                }
            };

            _.merge(config.params, params);

            return await this.$store.dispatch('social_media/index', config).then(() => {
                this.loading = false;
            });
        }
    },
    computed: {
        ...mapGetters('social_media', ['getByKey'])
    }
};
</script>
